import React, { useState, useRef, useContext, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Col, Input, FormGroup } from 'reactstrap';
import classNames from 'classnames';
import styles from './Login.module.css';
import SimpleReactValidator from 'simple-react-validator';
import { SessionContext } from '../context/SessionContext';
import { ReactComponent as ShieldBackground } from '../assets/images/forgot-password.svg';
import SpinnerButton from '../components/shared/SpinnerButton/SpinnerButton';

let loginContainer = styles.loginContainer;

const ForgotPassword = (props) => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;
    const accountNameToLower = accountName.toLowerCase();

    const [formData, setFormData] = useState({
        userEmail: ''
    });
    const [validationCheck, setValidationCheck] = useState(false);
    const [isDelearExists, setIsDelearExists] = useState(true);
    const [isSendEmailInProgress, setIsSendEmailInProgress] = useState(false);
    const [valid, setValid] = useState(false);

    const [, forceUpdate] = useState();

    const simpleValidator = useRef(
        new SimpleReactValidator({
            messages: {
                required: ':attribute is required.',
                email: 'Enter a valid email'
            },
            validators: {
                is_exists: {
                    message: ':attribute not found.',
                    rule: (val, params, validator) => {
                        return isDelearExists;
                    }
                },
                invalid: {
                    message: `Invalid :attribute`,
                    rule: (val) => {
                        return val === true;
                    }
                }
            },
            element: (message) => <div className='errorMsg'>{message.charAt(0).toUpperCase() + message.slice(1)}</div>
        })
    );

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        setIsDelearExists(true);
        setValidationCheck(true);
        simpleValidator.current.showMessages();
        forceUpdate(1);

        simpleValidator.current.showMessageFor('userEmail');
        const pattern = /^[-0-9a-zA-Z]+$/;
        //if (!value.match(pattern)) {
        //  setValid(true);
        //} else {
        //  simpleValidator.current.purgeFields();
        //  setValid(false);
        //}

        setFormData({
            ...formData,
            [name]: value
        });
    };

    const ForgotPass = (e) => {
        e.preventDefault();
        setIsDelearExists(true);
        if (simpleValidator.current.allValid() && !valid) {
            setIsSendEmailInProgress(true);
            setValidationCheck(true);
            let route = 'authentication/SendForgotPasswordCode';
            var model = {
                UserEmail: formData.userEmail
            };
            fetch(route, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(model)
            }).then((response) => {
                setIsSendEmailInProgress(false);
                if (response.status === 200) {
                    response
                        .text()
                        .then((data) => {
                            if (data == 'true') {
                                setIsDelearExists(true);
                                sessionContext.setLoginByEmailStatus(true);
                                sessionContext.updateForgotPassLink(false);
                                sessionContext.updateVerifyPassLink(true);
                                sessionContext.setIsForgotPassword(true);
                                props.history.push({
                                    pathname: '/verifylogin',
                                    state: {
                                        emailId: formData.userEmail
                                    }
                                });
                            } else {
                                setIsDelearExists(false);
                                setValidationCheck(true);
                                simpleValidator.current.showMessages();
                                forceUpdate(1);
                            }
                        })
                        .catch((err) => console.log(err));
                } else if (response.status === 404) {
                    setIsDelearExists(false);
                    setValidationCheck(true);
                    simpleValidator.current.showMessages();
                    forceUpdate(1);
                }
            });
        } else {
            setValidationCheck(true);
            simpleValidator.current.showMessages();
            forceUpdate(1);
        }
    };

    const handleRedirect = (e) => {
        e.preventDefault();
        sessionContext.updateForgotPassLink(false);

        return <Redirect to='/login' />;
    };

    return (
        <div className={styles.vendorForgotPass}>
            <ShieldBackground className={styles.shieldBackground} />
            <Container className={styles.mainContainer}>
                <Col
                    md='12'
                    lg='12'
                >
                    <Col
                        lg='6'
                        md='12'
                        xs='12'
                        className={classNames(loginContainer, 'p-0', 'mb-0')}
                    >
                        <h1 className='h3 mb-1'>
                            {accountNameToLower === 'ge' && 'Create/'}
                            Forgot Password
                        </h1>
                    </Col>
                    <Col
                        lg='5'
                        md='8'
                        xs='12'
                        className={classNames('p-0', 'pb-3', styles.infoText)}
                    >
                        <p className='mb-0'>
                            Please enter the Company Email associated with your account. We will send password reset
                            instructions to the email address associated with this account.
                        </p>
                    </Col>
                    <Col
                        lg='4'
                        md='5'
                        className={classNames(loginContainer, 'p-0', 'pb-3')}
                    >
                        <FormGroup
                            className={
                                (((!simpleValidator.current.check(formData.userEmail, 'required|is_exists')
                                    || !isDelearExists)
                                    && validationCheck)
                                    || valid)
                                && 'form-error'
                            }
                        >
                            <label
                                for='userEmail'
                                className='form-label'
                            >
                                Company Email
                            </label>
                            <span
                                aria-hidden='true'
                                className='required-indicator'
                            >
                                *
                            </span>
                            <Input
                                name='userEmail'
                                type='text'
                                className='form-control'
                                defaultValue={formData.userEmail}
                                onChange={handleInputChange}
                                disabled={isSendEmailInProgress}
                            />
                            {simpleValidator.current.message('userEmail', formData.userEmail, 'required|is_exists', {
                                messages: {
                                    required: 'Company Email Is required.'
                                }
                            })}
                            {simpleValidator.current.check(formData.userEmail, 'required|is_exists')
                                && !isDelearExists
                                && validationCheck && (
                                    <div
                                        className='errorMsg'
                                        aria-live='polite'
                                    >
                                        Company email does not match our records.
                                    </div>
                                )}
                            {valid
                                && simpleValidator.current.message('userEmail', formData.userEmail, 'invalid', {
                                    messages: {
                                        invalid: 'Please enter a valid Company Email.'
                                    }
                                })}
                        </FormGroup>
                        <SpinnerButton
                            type='primary'
                            spinning={isSendEmailInProgress}
                            disabled={isSendEmailInProgress}
                            onClick={ForgotPass}
                            text='SEND EMAIL'
                        />
                        <Col
                            md='12'
                            className={styles.enrollNow}
                        >
                            <a
                                href=''
                                onclick={handleRedirect}
                            >
                                Back to Login
                            </a>
                        </Col>
                    </Col>
                </Col>
            </Container>
        </div>
    );
};

export { ForgotPassword };
